import { render, staticRenderFns } from "./boxButton.vue?vue&type=template&id=f8507ae6&"
import script from "./boxButton.vue?vue&type=script&lang=js&"
export * from "./boxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports